// PARAQTA — Көшбасшылар (leaderboard).
// loadLeaders/loadLeaders2 — кері үйлесімділік үшін (екеуі де monthly tab-ты ашады).
// `currentUser` module-ден тыс state, сондықтан `window.currentUser` арқылы.

import { api } from '../../core/api.js';
import { esc } from '../../utils/format.js';

// 04.10.26: «Танымал кітаптар» (popular) және «Қала рейтингі» (cities) беттері
// өшірілді — кіруі жоқ еді, каталог пен рейтинг сол рөлді атқарады.

// ── IA v2.1 (01.09.26): екі деңгей — КІМ жарысады / НЕМЕН жарысады ──
// «Рейтинг = барлық жарыстың жалғыз үйі»: клуб лигасы «Біргеден» осында
// көшті, Мектептер қойындысы тизермен ашылды (лига 10 мектепте басталады).
let _entity = 'readers';
const KK_MONTHS_UP = ['ҚАҢТАР','АҚПАН','НАУРЫЗ','СӘУІР','МАМЫР','МАУСЫМ',
  'ШІЛДЕ','ТАМЫЗ','ҚЫРКҮЙЕК','ҚАЗАН','ҚАРАША','ЖЕЛТОҚСАН'];

export async function setLeadersEntity(ent, btn) {
  _entity = ['readers', 'clubs', 'schools'].includes(ent) ? ent : 'readers';
  document.querySelectorAll('.lb-etab').forEach((b) =>
    b.classList.toggle('on', b.dataset.ent === _entity));
  const views = { readers: 'lbReaders', clubs: 'lbClubs', schools: 'lbSchools' };
  Object.entries(views).forEach(([k, id]) => {
    const el = document.getElementById(id);
    if (el) el.style.display = k === _entity ? '' : 'none';
  });
  const badge = document.getElementById('lbMonthBadge');
  if (badge) badge.textContent = KK_MONTHS_UP[new Date().getMonth()] + ' · АЙ САЙЫН НӨЛДЕН';
  if (_entity === 'clubs') {
    const host = document.getElementById('lbClubs');
    // Лига рендері groups модулінде тұрады (бір ақиқат көзі) — динамикалық
    // импорт: айналмалы тәуелділік болмасын.
    import('../groups/index.js').then((m) => m.renderLigaInto(host)).catch(() => {
      if (host) host.innerHTML = '<p style="padding:16px;color:var(--ink4)">Жүктелмеді</p>';
    });
  } else if (_entity === 'schools') {
    renderSchoolsTeaser();
  }
}

// Мектептер қойындысы: лига ашылғанша — шын санауышпен тизер.
// Суық стартты жасырмаймыз: «4/10» деген санның өзі — шақыру.
async function renderSchoolsTeaser() {
  const host = document.getElementById('lbSchools');
  if (!host) return;
  host.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
  let d = null;
  try { d = await api('/api/mektepter/status'); } catch (_) {}
  if (!d || !d.ok) { host.innerHTML = '<p style="padding:16px;color:var(--ink4)">Жүктелмеді</p>'; return; }
  const pct = Math.min(100, Math.round((d.count / (d.target || 10)) * 100));
  const rows = (d.schools || []).map((s) =>
    `<div class="lb-sch-row"><span class="ok">✓</span>
      <div class="nm">${esc(s.name)}${s.city ? `<span>${esc(s.city)}</span>` : ''}</div>
    </div>`).join('');
  host.innerHTML = `
    <div class="lb-sch-hero">
      <div class="big">🏫</div>
      <div class="t">Мектептер лигасы ашылғалы тұр</div>
      <div class="s">Қазақстан мектептері айлық оқу жарысына шығады.
        Лига ${d.target} мектеп жиналғанда басталады.</div>
      <div class="cnt"><b>${d.count}</b><span>/ ${d.target} мектеп қосылды</span></div>
      <div class="bar"><i style="width:${pct}%"></i></div>
    </div>
    ${rows ? `<div class="lb-sch-list">
        <div class="lbl">АЛҒАШҚЫЛАР — ЛИГА ТАРИХЫНА ЖАЗЫЛАДЫ</div>${rows}</div>` : ''}
    <div class="lb-sch-cta">
      <b>Мектебің осы тізімде болсын ба?</b>
      <div class="m">Бір мұғалім бес минутта қосады — тегін</div>
      <button data-lb-sch-share>Мұғалімге сілтеме жіберу</button>
    </div>`;
  const shareBtn = host.querySelector('[data-lb-sch-share]');
  if (shareBtn) shareBtn.onclick = () => {
    const txt = 'PARAQTA — сыныбыңа тегін оқу панелі: кім қанша бет оқыды, серия, айлық есеп. paraqta.kz';
    if (navigator.share) { navigator.share({ text: txt }).catch(() => {}); return; }
    try {
      navigator.clipboard.writeText(txt);
      shareBtn.textContent = '✓ Көшірілді — мұғалімге жібер';
    } catch (_) {}
  };
}

export async function loadLeaders(by, btn) {
  // Басқа беттен келген терең сілтеме (мыс. Бірге → «Толық кесте»)
  const pending = window._pendingLeadersEntity;
  window._pendingLeadersEntity = null;
  await setLeadersEntity(pending || _entity || 'readers');
  if (_entity === 'readers') await loadLeaderTab('monthly');
}

export async function loadLeaders2() { await loadLeaders(); }

export async function loadLeaderTab(tab, btn) {
  if (btn) { document.querySelectorAll('.lb-mode-btn2').forEach(b => b.classList.remove('on')); btn.classList.add('on'); }
  const lb = document.getElementById('lBoard');
  const titleEl = document.getElementById('lbMonthTitle');
  const groupsSec = document.getElementById('lBoardGroupsSection');
  const AVCOLORS = ['#C49A6C','#8B5E34','#6EA8C9','#9E6EC9','#8ABD5A','#C96E8A','#4A7CA0','#C96E1E'];
  const MEDALS = ['\uD83E\uDD47','\uD83E\uDD48','\uD83E\uDD49'];

  function userRow(u, i, mainVal, subVal) {
    const nm = ((u.first_name||'')+' '+(u.last_name||'')).trim()||u.username||String(u.telegram_id);
    const ini = nm.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2)||'?';
    const isMe = window.currentUser && String(u.telegram_id)===String(window.currentUser.telegram_id);
    const col = AVCOLORS[i % AVCOLORS.length];
    const rank = i < 3 ? MEDALS[i] : (i+1);
    return '<div class="lb-row2'+(isMe?' me':'')+'">'+
      '<div class="lb-num2'+(i<3?' top3':'')+'">'+rank+'</div>'+
      '<div class="lb-av2" style="background:'+col+'20;color:'+col+'">'+ini+'</div>'+
      '<div class="lb-info2"><div class="lb-name2">'+esc(nm)+'</div><div class="lb-city2">'+esc(u.city||'')+'</div></div>'+
      '<div style="text-align:right"><div class="lb-val-main2">'+mainVal+'</div><div class="lb-val-sub2">'+subVal+'</div></div>'+
      '</div>';
  }

  // Stage 7.6: "Сенің орның" жолы — топ 30-дан тыс болғанда көрсетіледі.
  function meRow(rankNum, mainVal) {
    return '<div class="lb-row2 me" style="margin-top:10px;border-top:1px dashed rgba(28,26,22,.14);padding-top:12px;">'+
      '<div class="lb-num2">#'+rankNum+'</div>'+
      '<div class="lb-av2" style="background:#8B5E3422;color:#8B5E34">Сіз</div>'+
      '<div class="lb-info2"><div class="lb-name2">Сенің орның</div><div class="lb-city2">осы рейтингте</div></div>'+
      '<div style="text-align:right"><div class="lb-val-main2">'+mainVal+'</div></div>'+
      '</div>';
  }
  // me-row-ды тізімге қосу (топ 30-да болмаса ғана — әйтпесе жоғарыда highlight бар)
  function appendMe(me, mainVal) {
    if (me && me.rank && me.rank > 30) {
      lb.insertAdjacentHTML('beforeend', meRow(me.rank, mainVal));
    }
  }

  // Подиум — айдың үш үздігі (тек «Бет» қойындысында; мокап 01.09).
  function podium(users) {
    if (!users || users.length < 3) return '';
    const P_COLORS = ['linear-gradient(135deg,#E7C566,#B8860B)',
                      'linear-gradient(135deg,#B8BDC7,#8E96A3)',
                      'linear-gradient(135deg,#D9A87C,#A9713F)'];
    const cell = (u, i) => {
      const nm = ((u.first_name||'')+' '+(u.last_name||'')).trim()||u.username||'Оқырман';
      const ini = nm.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2)||'?';
      return `<div class="lb-pod-p${i===0?' first':''}">
        <div class="pa" style="background:${P_COLORS[i]}">${esc(ini)}</div>
        <div class="m">${MEDALS[i]}</div>
        <div class="nm">${esc(nm.split(' ')[0])}</div>
        <div class="v">${(u.total_pages||0).toLocaleString()}<span> бет</span></div>
      </div>`;
    };
    // Ортада — чемпион: 2-орын · 1-орын · 3-орын
    return `<div class="lb-pod">${cell(users[1],1)}${cell(users[0],0)}${cell(users[2],2)}</div>`;
  }

  if (tab === 'monthly') {
    lb.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
    const d = await api('/api/leaderboard/monthly');
    if (!d) return;
    if (!Array.isArray(d.users)) d.users = [];   // 03.11: қате/401 жауапта users жоқ → «e.users.length» құлауы (js_error, 10 адам)
    if (titleEl) titleEl.textContent = (d.month_name || 'Осы') + ' айының үздіктері · Оқылған бет саны бойынша';
    if (!d.users.length) {
      lb.innerHTML = '<p style="color:var(--ink4);font-size:.82rem;padding:16px">Осы айда деректер жоқ</p>';
    } else if (d.users.length >= 3) {
      lb.innerHTML = podium(d.users) +
        d.users.slice(3).map((u,i) => userRow(u,i+3,(u.total_pages||0).toLocaleString()+' бет',(u.sessions||0)+' сессия')).join('');
    } else {
      lb.innerHTML = d.users.map((u,i) => userRow(u,i,(u.total_pages||0).toLocaleString()+' бет',(u.sessions||0)+' сессия')).join('');
    }
    appendMe(d.me, (d.me ? (d.me.total_pages||0).toLocaleString() : '0') + ' бет');

    // Groups section
    if (groupsSec) groupsSec.style.display = '';
    const lbg = document.getElementById('lBoardGroups');
    if (lbg && d.groups && d.groups.length) {
      const GC = ['#7C5C35','#3E6040','#4A7CA0','#9E6EC9','#C96E8A'];
      lbg.innerHTML = d.groups.map((g,i) => {
        const rank = i<3?MEDALS[i]:(i+1);
        const col = GC[i%GC.length];
        return '<div class="lb-row2">'+
          '<div class="lb-num2'+(i<3?' top3':'')+'">'+rank+'</div>'+
          '<div class="lb-av2" style="background:'+col+'20;color:'+col+';font-size:.7rem">'+esc((g.name||'').slice(0,2))+'</div>'+
          '<div class="lb-info2"><div class="lb-name2">'+esc(g.name)+'</div>'+
          '<div class="lb-city2">'+(g.active_members||0)+' белсенді мүше</div></div>'+
          '<div style="text-align:right"><div class="lb-val-main2">'+(g.total_pages||0).toLocaleString()+' бет</div></div>'+
          '</div>';
      }).join('');
    }
  } else if (tab === 'time') {
    if (groupsSec) groupsSec.style.display = 'none';
    lb.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
    const d = await api('/api/leaderboard/time');
    if (!d) return;
    if (titleEl) titleEl.textContent = (d.month_name||'') + ' айының үздіктері · Оқу уақыты бойынша';
    if (!d.users || !d.users.length) {
      lb.innerHTML = '<div style="padding:32px 0;text-align:center;color:var(--ink4);font-size:.85rem">' +
        '<div style="font-size:2rem;margin-bottom:10px">⏱</div>' +
        '<div>Осы айда таймер деректері жоқ.</div>' +
        '<div style="margin-top:6px;font-size:.75rem">Оқу таймерін қолданып, рейтингте көрін!</div>' +
        '</div>';
      return;
    }
    lb.innerHTML = d.users.map((u, i) => {
      const h = u.hours || 0, m = u.minutes || 0;
      const timeStr = h > 0 ? h + ' сағ ' + (m > 0 ? m + ' мин' : '') : m + ' мин';
      const subVal = (u.sessions || 0) + ' сессия';
      return userRow(u, i, timeStr.trim(), subVal);
    }).join('');
    if (d.me) {
      const mh = d.me.hours || 0, mm = d.me.minutes || 0;
      const meStr = mh > 0 ? mh + ' сағ ' + (mm > 0 ? mm + ' мин' : '') : mm + ' мин';
      appendMe(d.me, meStr.trim());
    }
  } else if (tab === 'friends') {
    // Stage 7.7: Достар рейтингі — Жан дос (follow жүйесі)
    if (groupsSec) groupsSec.style.display = 'none';
    if (titleEl) titleEl.textContent = 'Достар рейтингі · осы айдағы оқылған бет';
    lb.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
    const d = await api('/api/leaderboard/friends');
    if (!d) return;
    if (d.status === 'premium_required') {
      lb.innerHTML = '<div style="padding:28px 18px;text-align:center;">' +
        '<div style="font-size:30px;margin-bottom:10px;">👥</div>' +
        '<div style="font-family:\'PT Serif\',Georgia,serif;font-size:16px;font-weight:700;margin-bottom:6px;">Достар рейтингі — Жан дос</div>' +
        '<div style="font-size:12.5px;color:var(--ink4);margin-bottom:14px;">Достарыңмен бәсекелес — кім осы айда көп оқыды?</div>' +
        '<button data-action="navigate" data-target="jandos" style="padding:10px 20px;background:var(--ac);color:#fff;border:none;border-radius:999px;font-size:12.5px;font-weight:600;cursor:pointer;">PARAQTA-ның Жан досы бол — 690₸</button>' +
        '</div>';
      return;
    }
    if (!d.users || !d.users.length) {
      lb.innerHTML = '<div style="padding:28px 18px;text-align:center;color:var(--ink4);">' +
        '<div style="font-size:30px;margin-bottom:10px;">🔍</div>' +
        '<div style="font-size:13px;line-height:1.55;">Әзірге ешкімді қадағаламайсың.<br>Оқырман профиліне кіріп <b style="color:var(--ac);">«Қадағалау»</b> бас — осында бәсекелесесің.</div>' +
        '</div>';
      return;
    }
    lb.innerHTML = d.users.map((u, i) =>
      userRow(u, i, (u.total_pages || 0).toLocaleString() + ' бет', esc(u.city || ''))
    ).join('');
  } else {
    if (groupsSec) groupsSec.style.display = 'none';
    if (titleEl) titleEl.textContent = tab === 'streak' ? 'Стрик бойынша рейтинг' : 'Оқылған кітап саны бойынша рейтинг';
    lb.innerHTML = '<div class="loading"><span class="spinner"></span>Жүктелуде...</div>';
    const d = await api('/api/leaderboard?by='+tab+'&limit=30');
    const rows = (d && d.users) || [];
    if (!rows.length) { lb.innerHTML = '<p style="color:var(--ink4);font-size:.82rem;padding:16px">\u2014</p>'; return; }
    lb.innerHTML = rows.map((u,i) => {
      const mainVal = tab==='streak' ? (u.streak||0)+' күн \uD83D\uDD25' : (u.books_count||0)+' кітап';
      const subVal  = tab==='streak' ? (u.books_count||0)+' кітап' : '\uD83D\uDD25 '+(u.streak||0)+' күн';
      return userRow(u, i, mainVal, subVal);
    }).join('');
    if (d && d.me) {
      appendMe(d.me, tab==='streak' ? (d.me.streak||0)+' күн' : (d.me.books_count||0)+' кітап');
    }
  }
}

